import {InMemoryCache} from '@jimmyn/apollo-client';
import {TypedTypePolicies} from 'api/apolloHelpers';
import introspection from 'api/possibleTypes';
import {fieldPolicy} from 'api/utils';

const typePolicies: TypedTypePolicies = {
  Query: {
    fields: {
      charge: fieldPolicy('Charge'),
      provider: fieldPolicy('Provider'),
      account: fieldPolicy('Account'),
      document: fieldPolicy('Document'),
      subscription: fieldPolicy('Subscription'),
      masterAccount: fieldPolicy('MasterAccount')
    }
  },
  ChargeEventObject: {
    keyFields: false
  },
  AccountEventObject: {
    keyFields: false
  },
  DocumentEventObject: {
    keyFields: false
  },
  SubscriptionEventObject: {
    keyFields: false
  }
};

export const cache = new InMemoryCache({typePolicies, possibleTypes: introspection.possibleTypes});
